import { AppState } from "../store";
import {
  createParamSelector,
  getUseQueryResultData,
  Site,
  SiteEntity,
  Trailer,
  TrailerEntity,
  transformSites,
  transformTrailers
} from "@ots-frontend/ots-data";
import { createSelector } from "@reduxjs/toolkit";
import {MapFilter} from "@ots-frontend/ots-ui";

export const getMapState = (state: AppState) => state.map.mapState;
export const getMapFocusPoint = (state: AppState) => state.map.focusPoint;
export const getMapFilter = (state: AppState) => state.map.filter;
export const getMapOpsMode = (state: AppState) => state.map.opsMode;
export const getMapOpsModeFilter = (state: AppState) => state.map.opsModeFilter;

const getSiteVisibilityParam = createParamSelector<MapFilter, boolean>(params => params.sites.show);
const getSiteStateParam = createParamSelector<MapFilter, string>(params => params.sites.criteria.state);
const getSiteTypesParam = createParamSelector<MapFilter, string>(params => params.sites.criteria.siteTypes.map(t => t.code).join(","));
const getSiteRouteIdParam = createParamSelector<MapFilter, string | undefined>(params => params.sites.criteria.routeId);

export const mapSiteSelector = () => createSelector(
  [getUseQueryResultData<Site[]>, getSiteVisibilityParam, getSiteStateParam, getSiteTypesParam, getSiteRouteIdParam],
  (data, show, state, typesAsString, routeId) => {

    let filteredSites: SiteEntity[] = [];

    const sites = transformSites(data);
    if (show) {
      filteredSites = sites.filter((s) => s.latLng);

      if (state === "active") {
        filteredSites = filteredSites.filter((s) => s.isActive);
      } else if (state === "occupied") {
        filteredSites = filteredSites.filter((s) => s.isOccupied);
      }

      const types = typesAsString.split(",");
      filteredSites = filteredSites.filter((s) => !s.type || types.includes(s.type.code));

      if (routeId) {
        filteredSites = filteredSites.filter((s) => s.routes?.map(r => r.id).includes(routeId) === true);
      }
    }

    return filteredSites;
  }
);

const getTrailerVisibilityParam = createParamSelector<MapFilter, boolean>(params => params.trailers.show);
const getTrailerStateParam = createParamSelector<MapFilter, string>(params => params.trailers.criteria.state);
const getTrailerCompanyIdParam = createParamSelector<MapFilter, string | undefined>(params => params.trailers.criteria.companyId);

export const mapTrailerSelector = () => createSelector(
  [getUseQueryResultData<Trailer[]>, getTrailerVisibilityParam, getTrailerStateParam, getTrailerCompanyIdParam],
  (data, show, state, companyId) => {

    let filteredTrailers: TrailerEntity[] = [];

    const trailers = transformTrailers(data);
    if (show) {
      for (const trailer of trailers) {
        const trailerState = trailer.state;
        if (trailerState) {
          switch (state) {
            case "inShift":
              if (trailerState.inShift) {
                filteredTrailers.push(trailer);
              }
              break;
            case "onSite":
              if (trailerState.onSite) {
                filteredTrailers.push(trailer);
              }
              break;
            case "stationary":
              if (trailerState.stationary) {
                filteredTrailers.push(trailer);
              }
              break;
            default:
              filteredTrailers.push(trailer);
              break;
          }
        }
      }

      if (companyId) {
        filteredTrailers = filteredTrailers.filter((t) => t.companyId === companyId);
      }
    }

    return filteredTrailers.filter((t) => t.latLng);
  }
);
